import * as accountApi from '@/network/api/accounts.api.js'
import * as operationsApi from '@/network/api/operations/operations.api.js'

/** requests Accounts Balance
@return {promise} - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await accountApi.requestAccountsBalances(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_BALANCE', data)
    }
    return res
}

/** requests Accounts Movements
@return {promise} - Accounts Movements request
*/
export const requestAccountsMovements = async (context, payload) => {
    const res = await accountApi.requestAccountsMovements(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_ACCOUNTS_MOVEMENTS', { pageNumber: payload.params.pageNumber, data: data })
    }
    return res
}

/** requests  Update Movement Selected Category
@return {promise} - Home Movements request
*/
export const updateSelectedCategoryFetch = async (context, payload) => {
    const res = await accountApi.updateSelectedCategoryFetch(payload)
    return res
}

/** requests  Movement Detail
@return {promise} - Home Movements request
*/
export const requestMovimentDetail = async (context, payload) => {
    const res = await accountApi.requestMovimentDetail(payload)
    return res
}

/** requests  Movement Detail
@return {promise} - Home Movements request
*/
export const requestGenericOperationDetail = async (context, payload) => {
    const res = await operationsApi.getOperationGenericDetail(payload)
    return res
}

/** requests Movements Categories
@return {promise} -Movements Categories request
*/
export const requestMovementsCategories = async context => {
    const res = await accountApi.requestMovementsCategories()
    if (res) {
        const data = res.data.data
		context.commit('SAVE_CATEGORIES', data.movementCategoryViews)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
